import { COLORS, marginXs } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled, { css } from 'styled-components';
import { CLEAR_BUTTON_GUTTER } from 'components/ClearValueButton/ClearValueButton.styled';

interface StyledProps {
  noImage: boolean;
  bgColor?: string;
  color?: string;
}

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${marginXs};
  position: relative;
  width: 100%;
  padding-right: ${CLEAR_BUTTON_GUTTER}rem;

  ${respondTo.bigPhone`
    flex-direction: column-reverse;
    gap: 20rem;
  `}
`;

export const Image = styled.img`
  max-width: 250rem;
  max-height: 130rem;
  width: 100%;
`;

export const ColorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${COLORS.GRAY_300};
  ${(props: StyledProps) =>
    props.bgColor &&
    css`
      background-color: ${(props: StyledProps) => props.bgColor};
    `};

  ${(props: StyledProps) =>
    props.noImage &&
    css`
      max-width: 100%;
      width: 50%;
    `};
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10rem;
  gap: 10rem;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10rem;
`;

export const Title = styled.label`
  color: ${COLORS.BLACK};
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  ${(props: StyledProps) =>
    props.color &&
    css`
      color: ${props.color};
    `};
  word-break: break-word;

  ${respondTo.bigTablet`
    font-size: 16rem;
  `}
`;

export const ColorCode = styled.label`
  color: ${COLORS.BLACK};
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  ${(props: StyledProps) =>
    props.color &&
    css`
      color: ${props.color};
    `};
  line-break: normal;
`;

export const ColorCollection = styled.span`
  display: block;
  font-size: 12px;
  color: ${COLORS.BLACK};
  ${(props: StyledProps) =>
    props.color &&
    css`
      color: ${props.color};
    `};
`;
